import { Button, Col, Row, Space, Table, Typography } from "antd";
import React, { useState, useEffect } from "react";
import { Badge } from "react-bootstrap";
import isEmpty from "lodash/isEmpty";

import DispatchSearch from "./DispatchSearch";
import PlainPrint from "./PlainPrint";
import Print from "./Print";
import moment from "moment";

import { useSearchData } from "../store";
const { Text } = Typography;

function Search() {
  const [searchData, setSearchData] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState(0);
  const [searchItemsLoading, setSearchItemsLoading] = useState(false);
  const [allSelectedOrders, setAllSelectedOrders] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isPrint, setIsPrint] = useState(false);
  const [isPlainPrint, setIsPlainPrint] = useState(false);

  const { searchdata, fetchSearchData, incrementPrintCount } = useSearchData();

  const getLineItemsName = (lineItems) => {
    if (isEmpty(lineItems)) {
      return "";
    }
    return lineItems
      .map(
        (lineItem) => ` ${lineItem.name} (${lineItem.fulfillable_quantity}) `
      )
      .join("/");
  };

  const handleclear = () => {
    setSearchResults([]);
  };

  useEffect(() => {
    if (isEmpty(searchdata)) {
      setSearchResults([]);
    } else {
      const tableData = searchdata.map((row) => ({
        key: row.id,
        customer_name: row.case.user.first_name,
        created_at: row.created_at,
        order_name: getLineItemsName(row.order_meta?.line_items) || "",
        order_number: row.order_number,
        prescription: row.prescription,
        status: row.status,
        count: row.count,
        order_display_id: row.order_display_id,
        user_id: row.user_id,
        line_items: row.order_meta.line_items,
        print_count: row.print_count,
      }));

      setSearchResults(tableData);
    }
  }, [searchdata]);

  const columns = [
    {
      title: "Order Display No",
      dataIndex: "order_display_id",
      key: "order_display_id",
      width: "160px",
    },
    {
      title: "New / Repeat",
      dataIndex: "count",
      key: "count",
      width: "160px",
      render: (count) => (
        <Badge key={count} color="primary">
          {count === 1 ? "NEW" : "REPEAT"}
        </Badge>
      ),
    },
    {
      title: "Order Status",
      dataIndex: "status",
      key: "status",
      width: "120px",
      align: "center",
      render: (status) => {
        return (
          <Badge key={status} color="primary">
            {status?.toUpperCase()}
          </Badge>
        );
      },
    },
    {
      title: "Details",
      key: "details",
      render: (record) => {
        const prescription = record.prescription;
        let prescriptionData = [];
        let printData = [];
        let recommendedPrescriptionData = [];

        prescription.map((prescription) => {
          if (prescription.version === 1) {
            const parsedPrescriptions = prescription.prescription;
            prescriptionData.push(parsedPrescriptions);
          } else {
            const parsedPrescriptions = JSON.parse(
              prescription.prescription
            ).prescription;

            parsedPrescriptions.map((parsedPrescriptions) => {
              if (parsedPrescriptions.showRecommendation === false) {
                printData.push(parsedPrescriptions);
              } else {
                recommendedPrescriptionData.push(parsedPrescriptions);
              }
            });
            return (prescriptionData = [
              ...printData,
              ...recommendedPrescriptionData,
            ]);
          }
        });

        let nestedData = [];
        if (prescriptionData) {
          nestedData = prescriptionData.map((prescriptionItem) => ({
            Medicine: prescriptionItem,
            Dosage: prescriptionItem.Dosage,
            Note: prescriptionItem.note,
            showRecommendation: prescriptionItem.showRecommendation,
          }));
        }

        const nestedcolumns = [
          {
            title: "Medicine",
            dataIndex: "Medicine",
            key: "Medicine",
            width: "490px",
            render: (text) => {
              if (typeof text === "object") {
                if (text.showRecommendation === true) {
                  return (
                    <>
                      <p>{text.Medicine}</p>
                      <p>(RECOMMENDED BY DOCTOR)</p>
                    </>
                  );
                } else {
                  return <p>{text.Medicine}</p>;
                }
              } else {
                return {
                  children: <p>{text}</p>,
                  props: {
                    colSpan: 10,
                  },
                };
              }
            },
          },
          {
            title: "Dosage",
            width: "490px",
            render: (record) => {
              if (record.Medicine.is_composition === true) {
                return (
                  <p>
                    {record.Medicine.Dosage} ({record.Medicine.composition})
                  </p>
                );
              } else {
                return <p>{record.Medicine.Dosage}</p>;
              }
            },
          },
          {
            title: "Note",
            dataIndex: "Note",
            key: "Note",
            width: "490px",
          },
        ];

        return (
          <>
            <Text style={{ fontWeight: "bold" }}>
              {record.customer_name} / {record.order_display_id} <br />
              {record.order_name}
            </Text>
            {""}
            <Table
              columns={nestedcolumns}
              dataSource={nestedData}
              loading={searchItemsLoading}
              pagination={false}
            />
          </>
        );
      },
    },
    {
      title: "Print Count",
      dataIndex: "print_count",
      key: "print_count",
      width: "120px",
      align: "center",
      render: (print_count) => {
        return (
          <Badge key={print_count} color="primary" style={{ fontSize: "20px" }}>
            {print_count}
          </Badge>
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setAllSelectedOrders([...selectedRows]);
      setSelectedKeys(selectedRowKeys);
    },
  };

  const handlePrint = () => {
    if (!isEmpty(allSelectedOrders)) {
      setIsPrint(true);
    }
  };

  const handlePlainPrintClick = () => {
    if (!isEmpty(allSelectedOrders)) {
      setIsPlainPrint(true);
    }
  };

  return (
    <div>
      {isPrint && <Print selectedOrdersData={allSelectedOrders} setIsPrint={setIsPrint} />}
      {isPlainPrint && (
        <div className="border border-danger">
          <PlainPrint
            selectedOrder={allSelectedOrders}
            setIsPlainPrint={setIsPlainPrint}
          />
        </div>
      )}

      <Row justify="space-between">
        <Col>
          <DispatchSearch
            setAllSelectedOrders={setAllSelectedOrders}
            setSelectedKeys={setSelectedKeys}
            setSearchData={setSearchData}
            paginationInfo={paginationInfo}
            setPaginationInfo={setPaginationInfo}
            search="searchPage"
            handleclear={handleclear}
          />
        </Col>
        <Col className="positon-fixed float-right">
          <Space>
            <Button
              type="primary"
              disabled={isEmpty(allSelectedOrders)}
              onClick={handlePlainPrintClick}
            >
              Plain Print
            </Button>
            <Button
              type="primary"
              onClick={handlePrint}
              disabled={isEmpty(allSelectedOrders)}
            >
              Print
            </Button>
          </Space>
        </Col>
      </Row>
      <Table
        className="mt-4"
        columns={columns}
        dataSource={searchResults}
        loading={searchItemsLoading}
        rowSelection={rowSelection}
        pagination={{
          current: pageNo,
        }}
      />
    </div>
  );
}

export default Search;
